import moment from 'moment';
import * as Sentry from '@sentry/react';
import {
  SET_TIME_ZONE,
  SET_INITIAL_DATE,
  SET_TIME_SLOT_SELECTED,
  SET_TOUCHED,
  SET_INITIAL_STATE,
  SET_PROJECT_ID,
} from '../actions/action-types';

export const initialState = {
  timeZone: 'US/Eastern',
  initialDate: moment().toISOString(),
  timeSlot: null,
  touched: false,
  projectId: null,
};

const schedule = (state = initialState, action) => {
  Sentry.setTag('redux.action', action.type);

  switch (action.type) {
    case SET_INITIAL_STATE: {
      return {
        ...initialState,
      };
    }

    case SET_PROJECT_ID: {
      return {
        ...state,
        projectId: action.payload,
      };
    }

    case SET_TIME_ZONE: {
      return {
        ...state,
        timeZone: action.payload,
      };
    }

    case SET_INITIAL_DATE: {
      return {
        ...state,
        initialDate: action.payload,
      };
    }

    case SET_TIME_SLOT_SELECTED: {
      return {
        ...state,
        timeSlot: action.payload,
      };
    }

    case SET_TOUCHED: {
      return {
        ...state,
        touched: action.payload,
      };
    }

    default:
      return state;
  }
};

export default schedule;
